import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CaseStudies.module.css';
import Footer from '../shared/Footer';

const CHALLENGE_SUBHEADING = "On-time performance and cost pressure demands tech-enabled Day-of-Ops";

const CHALLENGE_POINTS = [
  {
    text: "Manual Day-of-Ops limits operational optimality and growth, and is prone to human errors",
    hasImage: true
  },
  {
    text: "Struggle to protect profit margin from mounting infrastructure costs and gig economy shifts",
    hasImage: true
  },
  {
    text: "Lost critical expertise as seasoned staff retire, workforce gaps widen, and training takes time",
    hasImage: true
  },
  {
    text: "AI and robotics are no longer optional, and falling behind isn't either. Future-proof your operations",
    hasImage: true
  }
];

const FEATURE_HIGHLIGHTS = [
  {
    icon: '📊',
    title: 'Consolidate real-time ops data'
  },
  {
    icon: '🔄',
    title: 'From task driven to resource-optimized workflows'
  },
  {
    icon: '🎯',
    title: 'Match with available resources'
  }
];

const RESULTS_STATS = [
  {
    number: '100%',
    label: 'Service Standard Achievement'
  },
  {
    number: '20%+',
    label: 'Operational Capacity with Existing Resources in Dynamic Environment'
  },
  {
    number: '2x',
    label: 'More Profit Margin'
  }
];

function CaseStudies() {
  return (
    <div className={styles.section}>
      {/* Hero Section */}
      <div 
        className={styles.heroSection}
          style={{ 
            backgroundImage: `url(${process.env.PUBLIC_URL + '/images/case-studies/casestudieshero.png'})` 
          }}
      >
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Real-World Impact with Neural Lab Solutions</h1>
          <p className={styles.heroSubtitle}>
            See how leading airports and enterprises achieve measurable efficiency, scalability, and ROI with our AI-powered products.
          </p>
          <Link to="/#contact" className={styles.ctaButton}>
            Get in Touch
          </Link>
        </div>
      </div>

      {/* Case Study Block */}
      <div className={styles.caseStudyContainer}>
        <div className={styles.caseStudyWrapper}>
          
          {/* The Challenge Section */}
          <div className={styles.challengeSection}>
            <h2 className={styles.sectionTitle}>The Challenge</h2>
            <div className={styles.challengeSubheading}>
              {CHALLENGE_SUBHEADING}
            </div>
            <div className={styles.challengePoints}>
              {CHALLENGE_POINTS.map((point, index) => (
                <div key={index} className={styles.challengePoint}>
                  <div className={styles.challengeText}>
                    <span>{point.text}</span>
                  </div>
                  {point.hasImage && (
                    <div className={styles.imagePlaceholder}>
                      <img 
                        src={process.env.PUBLIC_URL + `/images/case-studies/case-studies${index + 1}.jpg`} 
                        alt={`Case Study ${index + 1}`} 
                        className={styles.caseStudyImage}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* The Solution Section */}
          <div className={styles.solutionSection}>
            <h2 className={styles.sectionTitle}>The Solution – OpsAssist</h2>
            <div className={styles.featuresGrid}>
              {FEATURE_HIGHLIGHTS.map((feature, index) => (
                <div key={index} className={styles.featureTile}>
                  <div className={styles.featureIcon}>{feature.icon}</div>
                  <div className={styles.featureTitle}>{feature.title}</div>
                </div>
              ))}
            </div>
            
            <Link to="/ops-assist" className={styles.exploreLink}>
              Explore OpsAssist →
            </Link>
          </div>

          {/* The Results Section */}
          <div className={styles.resultsSection}>
            <h2 className={styles.sectionTitle}>The Results</h2>
            <div className={styles.resultsGrid}>
              {RESULTS_STATS.map((stat, index) => (
                <div key={index} className={styles.resultTile}>
                  <div className={styles.resultNumber}>{stat.number}</div>
                  <div className={styles.resultLabel}>{stat.label}</div>
                </div>
              ))}
            </div>
            {/* <div className={styles.testimonialVideo}>
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/7gOaNonoiOY"
                title="Henry Low Testimonial"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div> */}
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CaseStudies;
